import { Component, Input, input } from '@angular/core';

@Component({
  selector: 'app-ivy-face-animated',
  standalone: true,
  imports: [],
  templateUrl: './ivy-face-animated.component.html',
  styleUrl: './ivy-face-animated.component.scss'
})
export class IvyFaceAnimatedComponent {

  @Input()
  size: number = 92

}
